import ApiError from "./";
import ProblemDetail, {isProblemDetail} from "./problem-detail";
export default class FailedValidation extends ApiError {
  readonly name: string = "FailedValidation";
  readonly failures: {[key: string]: string[]};

  constructor(problem: FailedValidationProblem) {
    super(problem);
    this.failures = problem.failures;
  }
}

export interface FailedValidationProblem extends ProblemDetail {
  failures: {[key: string]: string[]};
}

export function isFailedValidationProblem(obj: unknown): obj is FailedValidationProblem {
  if (isProblemDetail(obj)) {
    return (obj as FailedValidationProblem).failures !== undefined;
  }
  return false;
}
